import * as React from "react";
import { SwxlProps, CategoryProps } from "./typings";
import { UitkCard, UitkCardContent, UitkCardLink, UitkCardTextSegment } from "uitk-react-cards";
import { UitkIcon } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { inject } from "mobx-react";
import { UitkDialogContent, UitkFullscreenDialog } from "uitk-react-dialog";
import { UitkToolbar } from "uitk-react-toolbar";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";
import { withLocalization } from "bernie-l10n";

export const Swxl = (props: SwxlProps) => {
  const flexComponent = props.flexComponent;

  if (!flexComponent || !flexComponent.model.categories) {
    return null;
  }

  let { categories } = flexComponent.model;
  const keyHelper = new ItemKeyHelper(flexComponent.name);

  categories = categories.filter(
    category => category.name && category.links && category.links.length > 0
  );

  if (categories.length === 0) {
    return null;
  }

  return (
    <div
      className="Swxl uitk-cell uitk-grid all-cell-1-1"
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      {categories.map(category => (
        <SwxlCategory category={category} key={keyHelper.next()} />
      ))}
    </div>
  );
};

@withLocalization
@inject("routeStore", "analytics")
class SwxlCategory extends React.Component<CategoryProps> {
  public constructor(props: CategoryProps) {
    super(props);

    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  private openDialog() {
    const trackingInfo: FlexTrackingInfo = {
      moduleName: "swxl",
      action: Action.CLICK,
      rfrr: `dialog.open`
    };
    sendDelayedTrackEvent(trackingInfo, this.props.analytics);

    if (this.props.routeStore) {
      this.props.routeStore.updateSearch({ pwaDialog: `${this.props.category.name}` });
    }
  }

  private closeDialog() {
    const trackingInfo: FlexTrackingInfo = {
      moduleName: "swxl",
      action: Action.CLICK,
      rfrr: `dialog.close`
    };
    sendDelayedTrackEvent(trackingInfo, this.props.analytics);

    if (this.props.routeStore) {
      this.props.routeStore.goBack();
    }
  }

  public render() {
    const { category } = this.props;
    const keyHelper = new ItemKeyHelper("hidden-link");

    const toolbarTitle = this.props.l10n.formatText("swxl.dialog.title");

    const swxlLinks = category.links.map(link => (
      <UitkLink key={keyHelper.next()}>
        <TrackedLink moduleName="swxl" rfrr={category.name} href={link.url} linkName={link.title}>
          <span>{link.title}</span>
        </TrackedLink>
      </UitkLink>
    ));

    return (
      <div className="uitk-cell all-t-margin-three">
        <UitkCard>
          <UitkCardContent>
            <UitkCardTextSegment>
              <h2 className="uitk-type-heading-400">
                {`${category.name} (${category.links.length})`}
                <UitkIcon name="chevron_right" />
              </h2>
              <UitkCardLink>
                <a data-testid={`category-${category.name}`} onClick={this.openDialog} />
              </UitkCardLink>
              <div className="is-visually-hidden">{swxlLinks}</div>
            </UitkCardTextSegment>
          </UitkCardContent>
        </UitkCard>
        <QueryRoute query={{ pwaDialog: `${category.name}` }}>
          <Layer id={`category-${category.name}`}>
            <UitkFullscreenDialog dialogShow={true}>
              <UitkToolbar
                header={toolbarTitle}
                iconLabel="Close the dialog"
                action={this.closeDialog}
              />
              <UitkDialogContent>
                <h2 className="uitk-type-heading-600">{category.name}</h2>
                <div className="all-t-margin-three">{swxlLinks}</div>
              </UitkDialogContent>
            </UitkFullscreenDialog>
          </Layer>
        </QueryRoute>
      </div>
    );
  }
}

export default Swxl;
